export default __webpack_public_path__ + "static/what-if-media-thumbnail-fcdfb266ef7fc9af53ea82799195e517.webp";